import dayjs from 'dayjs'

export const startDate = dayjs().subtract(1, 'year').format('YYYY-MM-DD')
export const endDate = dayjs().day(-15).format('YYYY-MM-DD')//someFutureSunday
export const endDatePublic = dayjs().day(+6).format('YYYY-MM-DD')//someFutureSunday
export const displayDate = dayjs().day(-15).format('YYYY-MM-DD')
export const lastDisplayDate = dayjs().day(-15).format('YYYY-MM-DD')
export const weekEndDate = dayjs().day(-15).format('YYYY-MM-DD')
export const lastweekEndDate = dayjs().day(-15).format('YYYY-MM-DD')
export const displayDateHome = dayjs().day(-15).format('YYYY-MM-DD')
export const displayStartDate = dayjs().day(-30).format('YYYY-MM-DD')
